import React from "react";
import Modal from "react-bootstrap/Modal";
import { BsCalendarWeekFill } from "react-icons/bs";
import UserCreation from "../components/UserCreation";

const UserCreateUpdateModal = ({ visible, close, user, updateUser }) => {
  const getTitle = () => {
    if (user?.id !== null && user?.id !== undefined) return "Edit User";
    return "Add new User";
  };

  return (
    <Modal
      show={visible}
      onHide={close}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          <h1 className={"text-axis-offblack icon-text-wrapper"}>
            <BsCalendarWeekFill /> {getTitle()}
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <UserCreation
          user={user}
          onComplete={(s) => {
            if (updateUser !== null && updateUser !== undefined) updateUser(s);
            close();
          }}
          close={close}
        />
      </Modal.Body>
    </Modal>
  );
};

export default UserCreateUpdateModal;
